import type { ActiveGameData } from '@ps/web-poker-types';
import { ActiveGameType } from '@ps/web-poker-types';
import type React from 'react';

import GameItemCash from './GameItemCash';
import GameItemSAG from './GameItemSAG';
import GameItemTourney from './GameItemTourney';

interface Props {
  game: ActiveGameData;
}

const getGameItem = (game: ActiveGameData) => {
  switch (game.type) {
    case ActiveGameType.Tourney:
      return <GameItemTourney game={game} />;
    case ActiveGameType.Cash:
    case ActiveGameType.Zoom:
      return <GameItemCash game={game} />;
    case ActiveGameType.SAG:
      return <GameItemSAG game={game} />;
    default:
      return null;
  }
};

const GameItem: React.FC<Props> = ({ game }) => getGameItem(game);

export default GameItem;
